document.addEventListener('DOMContentLoaded', function() {
  // Click handlers for Shop the Look triggers
  const shopTheLookTriggers = document.querySelectorAll('.shop-the-look-trigger');
  
  shopTheLookTriggers.forEach(function(trigger) {
    const triggerButton = trigger.querySelector('.shop-the-look__trigger-button');
    if (triggerButton) {
      // Add both click and touchstart for better mobile support
      ['click', 'touchstart'].forEach(function(eventType) {
        triggerButton.addEventListener(eventType, function(event) {
          event.preventDefault();
          event.stopPropagation();
          
          const optionsContainer = trigger.closest('.card-wrapper').querySelector('.shop-the-look-options');
          const trackingTitle = trigger.getAttribute('data-tracking-title');
          
          if (!optionsContainer) {
            console.error('Shop the Look: Options container not found');
            return;
          }
          
          // Prevent double firing on devices that trigger both events
          if (event.type === 'touchstart') {
            event.target.dataset.touched = 'true';
            setTimeout(function() {
              delete event.target.dataset.touched;
            }, 500);
          }
          
          if (event.type === 'click' && event.target.dataset.touched === 'true') {
            return;
          }
          
          if (window.matchMedia("(max-width: 767px)").matches) {
            openMobileModal(optionsContainer, trackingTitle);
          } else {
            openDesktopOverlay(optionsContainer, trackingTitle);
          }
        }, { passive: false });
      });
    }
  });

  function openMobileModal(optionsContainer, trackingTitle) {
    // Store original parent for restoration
    const originalParent = optionsContainer.parentNode;

    // Create a placeholder element to mark the original position
    const placeholder = document.createElement('div');
    placeholder.className = 'shop-the-look-placeholder';
    placeholder.style.display = 'none';
    originalParent.insertBefore(placeholder, optionsContainer);

    // Store reference to placeholder on the container
    optionsContainer.__placeholder = placeholder;

    // Create modal wrapper if not exists
    let modalWrapper = document.querySelector('.shop-the-look-modal-wrapper');
    if (!modalWrapper) {
      modalWrapper = document.createElement('div');
      modalWrapper.className = 'shop-the-look-modal-wrapper';
      document.body.appendChild(modalWrapper);
    }

    // Move the actual container to the modal wrapper
    modalWrapper.appendChild(optionsContainer);
    optionsContainer.classList.add('shop-the-look-modal-mobile');
    optionsContainer.classList.add('active');

    // Create backdrop if not exists
    let backdrop = document.querySelector('.shop-the-look-backdrop');
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'shop-the-look-backdrop';
      document.body.appendChild(backdrop);
    }

    // Show backdrop
    backdrop.classList.add('active');
    document.body.style.overflow = 'hidden';

    // Setup event listeners if not already done
    setupShopTheLookEventListeners(optionsContainer, trackingTitle);

    // Mark as mobile modal
    optionsContainer.dataset.isMobileModal = 'true';

    // Close on backdrop click
    backdrop.onclick = function() {
      closeMobileModal(optionsContainer);
    };
  }

  function openDesktopOverlay(optionsContainer, trackingTitle) {
    // Add desktop overlay styling
    optionsContainer.classList.add('active');
    
    // Setup event listeners if not already done
    setupShopTheLookEventListeners(optionsContainer, trackingTitle);
  }

  function closeMobileModal(modalElement) {
    if (!modalElement) return;

    // Remove modal classes
    modalElement.classList.remove('active');
    modalElement.classList.remove('shop-the-look-modal-mobile');

    // Move element back to original location using placeholder
    if (modalElement.dataset.isMobileModal === 'true' && modalElement.__placeholder) {
      const placeholder = modalElement.__placeholder;

      // Move the element back to where the placeholder is
      if (placeholder && placeholder.parentNode) {
        placeholder.parentNode.insertBefore(modalElement, placeholder);
        placeholder.remove();
      }

      // Clean up references
      delete modalElement.__placeholder;
      delete modalElement.dataset.isMobileModal;
    }

    // Restore body scroll
    document.body.style.overflow = '';

    // Hide backdrop
    const backdrop = document.querySelector('.shop-the-look-backdrop');
    if (backdrop) {
      backdrop.classList.remove('active');
    }
  }

  function closeDesktopOverlay(optionsContainer) {
    optionsContainer.classList.remove('active');
  }

  function setupShopTheLookEventListeners(container, trackingTitle) {
    // Skip if already setup
    if (container.getAttribute('data-listeners-setup')) return;
    container.setAttribute('data-listeners-setup', 'true');

    // Close button handler
    const closeButton = container.querySelector('.shop-the-look-options__close');
    if (closeButton) {
      closeButton.addEventListener('click', function() {
        if (window.matchMedia("(max-width: 767px)").matches) {
          closeMobileModal(container);
        } else {
          closeDesktopOverlay(container);
        }
      });
    }

    // Prevent focus jumping on metal label clicks
    const metalLabels = container.querySelectorAll('.shop-the-look-variants label.is-metal');
    metalLabels.forEach(function(label) {
      label.addEventListener('click', function(e) {
        e.preventDefault();
        const inputId = label.getAttribute('for');
        const input = document.getElementById(inputId);
        if (input && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    // Variant selection change handlers for radio buttons
    const variantInputs = container.querySelectorAll('.shop-the-look-variants input[type="radio"]');
    variantInputs.forEach(function(input) {
      input.addEventListener('change', function() {
        updateProductPrice(input);
        updateTotalPrice(container);
      });
    });

    // Variant selection change handlers for select dropdowns
    const variantSelects = container.querySelectorAll('.shop-the-look-variants__select');
    variantSelects.forEach(function(select) {
      select.addEventListener('change', function() {
        updateProductPrice(select);
        updateTotalPrice(container);

        // Clear validation errors when user makes a valid selection
        if (select.value && select.value !== '') {
          const productContainer = select.closest('.shop-the-look-product');
          clearValidationErrors(productContainer);

          // Also clear bulk validation errors
          const bulkError = container.querySelector('.shop-the-look-bulk-error');
          if (bulkError) {
            bulkError.remove();
          }
        }
      });
    });

    // Individual add to cart buttons
    const addSingleButtons = container.querySelectorAll('.shop-the-look__add-single, .shop-the-look__add-single--text');
    addSingleButtons.forEach(function(button) {
      button.addEventListener('click', function(event) {
        event.preventDefault();
        const productId = button.getAttribute('data-product-id');
        addSingleToCart(button, productId, trackingTitle);
      });
    });

    // Add all to cart button
    const addAllButton = container.querySelector('.shop-the-look__add-all');
    if (addAllButton) {
      addAllButton.addEventListener('click', function(event) {
        event.preventDefault();
        addAllToCart(container, trackingTitle);
      });
    }

    // Close on backdrop click
    container.addEventListener('click', function(event) {
      if (event.target === container && container.classList.contains('active')) {
        if (window.matchMedia("(max-width: 767px)").matches) {
          closeMobileModal(container);
        } else {
          closeDesktopOverlay(container);
        }
      }
    });

    // Initialize total price
    updateTotalPrice(container);
  }

  function updateProductPrice(variantInput) {
    const productContainer = variantInput.closest('.shop-the-look-product');
    const variantData = getProductVariants(productContainer);
    const selectedVariant = getSelectedVariant(productContainer, variantData);
    
    if (selectedVariant) {
      const priceElement = productContainer.querySelector('.price');
      if (priceElement) {
        priceElement.textContent = formatMoney(selectedVariant.price);
      }
      
      // Update add to cart button state
      const addButton = productContainer.querySelector('.shop-the-look__add-single');
      if (addButton) {
        if (selectedVariant.available) {
          addButton.disabled = false;
          addButton.textContent = 'Add to Cart';
        } else {
          addButton.disabled = true;
          addButton.textContent = 'Sold Out';
        }
      }
    }
  }

  function updateTotalPrice(container) {
    let total = 0;
    const productContainers = container.querySelectorAll('.shop-the-look-product');
    
    productContainers.forEach(function(productContainer) {
      const variantData = getProductVariants(productContainer);
      const selectedVariant = getSelectedVariant(productContainer, variantData);
      if (selectedVariant) {
        total += selectedVariant.price;
      }
    });
    
    const totalElement = container.querySelector('.shop-the-look__total');
    if (totalElement) {
      totalElement.textContent = formatMoney(total);
    }
  }

  function getProductVariants(productContainer) {
    const variantScript = productContainer.querySelector('.product-variants-json');
    return variantScript ? JSON.parse(variantScript.textContent) : [];
  }

  function getSelectedVariant(productContainer, variantData) {
    const selectedOptions = [];

    // Get all variant fieldsets to maintain correct order
    const fieldsets = productContainer.querySelectorAll('.product-form__input, .variant-input-wrapper');

    fieldsets.forEach(function(fieldset) {
      // Check for radio inputs
      const radioInput = fieldset.querySelector('input[type="radio"]:checked');
      if (radioInput) {
        selectedOptions.push(radioInput.value);
        return;
      }

      // Check for select dropdown
      const selectInput = fieldset.querySelector('.shop-the-look-variants__select');
      if (selectInput) {
        selectedOptions.push(selectInput.value);
        return;
      }
    });

    // Find matching variant by options array
    return variantData.find(function(variant) {
      return variant.options.every(function(option, index) {
        return selectedOptions[index] === option;
      });
    });
  }

  function validateProductSelections(productContainer) {
    const productTitle = productContainer.querySelector('.shop-the-look-product__title')?.textContent || 'this product';

    // Check for required size selections
    const sizeSelects = productContainer.querySelectorAll('.shop-the-look-variants__select[required]');
    for (let select of sizeSelects) {
      if (!select.value || select.value === '') {
        return {
          isValid: false,
          message: `Please select a size for ${productTitle}`,
          element: select
        };
      }
    }

    return { isValid: true };
  }

  function showValidationError(productContainer, message) {
    // Remove any existing error messages
    clearValidationErrors(productContainer);

    // Find the invalid select element
    const invalidSelect = productContainer.querySelector('.shop-the-look-variants__select[required]');
    if (invalidSelect && (!invalidSelect.value || invalidSelect.value === '')) {
      invalidSelect.classList.add('error');
    }

    // Create and show error message
    const errorElement = document.createElement('div');
    errorElement.className = 'shop-the-look-error-message';
    errorElement.textContent = message;

    // Insert error message after the product info
    const productInfo = productContainer.querySelector('.shop-the-look-product__info');
    if (productInfo) {
      productInfo.appendChild(errorElement);
    }

    // Auto-remove error after 5 seconds
    setTimeout(() => {
      clearValidationErrors(productContainer);
    }, 5000);
  }

  function clearValidationErrors(productContainer) {
    // Remove error styling from selects
    const errorSelects = productContainer.querySelectorAll('.shop-the-look-variants__select.error');
    errorSelects.forEach(select => select.classList.remove('error'));

    // Remove error messages
    const errorMessages = productContainer.querySelectorAll('.shop-the-look-error-message');
    errorMessages.forEach(message => message.remove());
  }

  function showBulkValidationError(container, invalidProducts) {
    // Remove any existing bulk error
    const existingError = container.querySelector('.shop-the-look-bulk-error');
    if (existingError) {
      existingError.remove();
    }

    // Create bulk error message
    const errorElement = document.createElement('div');
    errorElement.className = 'shop-the-look-bulk-error';

    let message = 'Please select sizes for: ';
    if (invalidProducts.length === 1) {
      message = `Please select a size for ${invalidProducts[0]}`;
    } else if (invalidProducts.length === 2) {
      message = `Please select sizes for ${invalidProducts[0]} and ${invalidProducts[1]}`;
    } else {
      message = `Please select sizes for ${invalidProducts.slice(0, -1).join(', ')}, and ${invalidProducts[invalidProducts.length - 1]}`;
    }

    errorElement.textContent = message;

    // Insert before the Add All button
    const addAllButton = container.querySelector('.shop-the-look__add-all');
    if (addAllButton) {
      addAllButton.parentNode.insertBefore(errorElement, addAllButton);
    }

    // Auto-remove after 7 seconds
    setTimeout(() => {
      if (errorElement.parentNode) {
        errorElement.remove();
      }
    }, 7000);
  }

  async function addSingleToCart(button, productId, trackingTitle) {
    const productContainer = button.closest('.shop-the-look-product');

    // Validate that all required options are selected
    const validationResult = validateProductSelections(productContainer);
    if (!validationResult.isValid) {
      showValidationError(productContainer, validationResult.message);
      return;
    }

    const variantData = getProductVariants(productContainer);
    const selectedVariant = getSelectedVariant(productContainer, variantData);

    if (!selectedVariant || !selectedVariant.available) {
      return;
    }
    
    button.classList.add('loading');
    
    try {
      await addToCartWithTracking(selectedVariant.id, 1, trackingTitle);
      
      // Show success state briefly
      const originalText = button.textContent;
      button.textContent = 'Added!';
      button.classList.remove('loading');
      
      setTimeout(function() {
        button.textContent = originalText;
      }, 2000);
      
    } catch (error) {
      console.error('Failed to add product to cart:', error);
      button.classList.remove('loading');
      button.textContent = 'Error - Try Again';
      
      setTimeout(function() {
        button.textContent = 'Add to Cart';
      }, 3000);
    }
  }

  async function addAllToCart(container, trackingTitle) {
    const addAllButton = container.querySelector('.shop-the-look__add-all');
    const productContainers = container.querySelectorAll('.shop-the-look-product');

    // Validate all products first
    const invalidProducts = [];
    productContainers.forEach(function(productContainer) {
      const validationResult = validateProductSelections(productContainer);
      if (!validationResult.isValid) {
        const productTitle = productContainer.querySelector('.shop-the-look-product__title')?.textContent || 'Unknown product';
        invalidProducts.push(productTitle);
        showValidationError(productContainer, validationResult.message);
      }
    });

    // If any products are invalid, show summary and return
    if (invalidProducts.length > 0) {
      showBulkValidationError(container, invalidProducts);
      return;
    }

    // Clear any existing validation errors
    productContainers.forEach(clearValidationErrors);

    const items = [];

    // Collect all selected variants
    productContainers.forEach(function(productContainer) {
      const variantData = getProductVariants(productContainer);
      const selectedVariant = getSelectedVariant(productContainer, variantData);

      if (selectedVariant && selectedVariant.available) {
        items.push({
          id: selectedVariant.id,
          quantity: 1,
          properties: {
            '_shop_the_look': trackingTitle
          }
        });
      }
    });

    if (items.length === 0) {
      return;
    }
    
    addAllButton.classList.add('loading');
    
    try {
      const cartData = {
        items: items,
        sections: cartSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      };
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(cartData)
      });
      
      if (response.ok) {
        const parsedState = await response.json();
        await updateCartSections(parsedState);
        updateShippingThreshold();
        
        // Show cart notification
        window.scrollTo(0, 0);
        const cartNotification = document.getElementById('cart-notification');
        if (cartNotification) {
          cartNotification.focus();
          cartNotification.classList.add('active');
        }
        
        // Update mini cart
        const notEmptyCart = document.getElementById('shopify-section-mini-cart');
        if (notEmptyCart) {
          const miniCartContainer = notEmptyCart.querySelector('.mini-cart-container');
          if (miniCartContainer) {
            miniCartContainer.classList.add('not-empty');
          }
        }
        
        // Close modal if open
        if (container.classList.contains('active')) {
          if (window.matchMedia("(max-width: 767px)").matches) {
            closeMobileModal(container);
          } else {
            closeDesktopOverlay(container);
          }
        }
        
      } else {
        throw new Error('Failed to add items to cart');
      }
      
    } catch (error) {
      console.error('Failed to add all items to cart:', error);
      addAllButton.innerHTML = 'Error - Try Again';
      
      setTimeout(function() {
        const totalSpan = addAllButton.querySelector('.shop-the-look__total');
        const totalText = totalSpan ? totalSpan.outerHTML : '';
        addAllButton.innerHTML = 'Add All to Cart ' + totalText;
      }, 3000);
    } finally {
      addAllButton.classList.remove('loading');
    }
  }

  async function addToCartWithTracking(variantId, quantity, trackingTitle) {
    const cartData = {
      items: [{
        id: variantId,
        quantity: quantity,
        properties: {
          '_shop_the_look': trackingTitle
        }
      }],
      sections: cartSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    };
    
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(cartData)
    });
    
    if (response.ok) {
      const parsedState = await response.json();
      await updateCartSections(parsedState);
      updateShippingThreshold();
      
      // Show cart notification
      window.scrollTo(0, 0);
      const cartNotification = document.getElementById('cart-notification');
      if (cartNotification) {
        cartNotification.focus();
        cartNotification.classList.add('active');
      }
      
      const notEmptyCart = document.getElementById('shopify-section-mini-cart');
      if (notEmptyCart) {
        const miniCartContainer = notEmptyCart.querySelector('.mini-cart-container');
        if (miniCartContainer) {
          miniCartContainer.classList.add('not-empty');
        }
      }
    } else {
      throw new Error('Failed to add to cart');
    }
  }

  // Helper functions
  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', { 
      style: 'currency', 
      currency: 'USD' 
    }).format(cents / 100);
  }

  // Reuse existing cart functions from quick shop
  function cartSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items')?.dataset?.id || 'main-cart-items',
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset?.id || 'main-cart-footer',
        selector: '.js-contents',
      }
    ];
  }

  async function updateCartSections(parsedState) {
    cartSectionsToRender().forEach((section) => {
      const elementToReplace = document.getElementById(section.id);
      if (elementToReplace) {
        const targetElement = elementToReplace.querySelector(section.selector);
        if (targetElement && parsedState.sections[section.section]) {
          const innerHTMLValue = findCollectionSectionInnerHTML(parsedState.sections[section.section], section.selector);
          if (innerHTMLValue) {
            targetElement.innerHTML = innerHTMLValue;
          }
        }
      }
    });
    
    // Call existing function if available
    if (typeof updateCartHeaderFooter === 'function') {
      updateCartHeaderFooter();
    }
  }

  function findCollectionSectionInnerHTML(html, selector) {
    if (!html) return null;
    const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
    const element = parsedDocument.querySelector(selector);
    return element ? element.innerHTML : null;
  }

  // Mobile app detection
  function isInApp() {
    return navigator.userAgent.toLowerCase().includes('canvas');
  }

  if (isInApp()) {
    document.body.classList.add('hello-adorn-app');
  }

  // Add escape key listener for closing overlays
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      const activeContainer = document.querySelector('.shop-the-look-options.active');
      if (activeContainer) {
        if (window.matchMedia("(max-width: 767px)").matches) {
          closeMobileModal(activeContainer);
        } else {
          closeDesktopOverlay(activeContainer);
        }
      }
    }
  });
  
  // Initialize Swiper for shop-the-look cards on mobile
  function initShopTheLookSwipers() {
    const shopTheLookCards = document.querySelectorAll('[class^="shop-the-look-swiper-"]');
    shopTheLookCards.forEach(function(card) {
      const matches = card.className.match(/shop-the-look-swiper-(\d+)/);
      if (matches && matches[1]) {
        const index = matches[1];
        if (typeof Swiper !== 'undefined') {
          new Swiper('.shop-the-look-swiper-' + index, {
            pagination: {
              el: '.shop-look-pagination-' + index,
              clickable: true,
            },
            loop: false,
            slidesPerView: 1,
            spaceBetween: 0,
          });
        }
      }
    });
  }
  
  // Initialize swipers when ready
  if (typeof Swiper !== 'undefined') {
    initShopTheLookSwipers();
  } else {
    // Wait for Swiper to load
    setTimeout(initShopTheLookSwipers, 1000);
  }
});